import { NavitasProfessional } from 'screens/navitas-professional';

export default NavitasProfessional;
